import { ThemeUICSSObject } from '@apia/theme';

const autocompleteInput: ThemeUICSSObject = {
  '.autocompleteInput__Input': {
    width: '100%',
  },
  '&.autocompleteInput': {
    width: '100%',
    position: 'relative',
  },
  '.autocompleteInput__Icon': {
    position: 'absolute',
    width: 'auto',
    top: '0',
    right: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    bottom: '0',
    height: '100%',
    padding: '12px',
    color: 'palette.text.primary',
    background: 'palette.background.default',
    border: '1px solid',
    borderColor: 'palette.border.field',
  },
  '.autocompleteInput__Wrapper': {
    backgroundColor: 'palette.background.paper',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    zIndex: '1',
    position: 'relative',
  },
  '.autocompleteInput__AutocompleteItem': {
    width: '100%',
    backgroundColor: 'palette.background.paper',
    color: 'palette.primary.contrastText',
    border: '1px solid palette.primary.main',
    textAlign: 'start',
  },
  '.autocompleteInput__AutocompleteItem:focus': {
    backgroundColor: 'palette.primary.main',
    color: 'palette.text.secondary',
  },
  '.autocompleteInput__Options': {
    position: 'absolute',
    width: '100%',
  },

  resultsBox: {
    '.autocompleteInput__Options': {
      background: 'palette.background.paper',
      display: 'flex',
      flexDirection: 'column',
      maxHeight: '47vh',
      overflow: 'scroll',
      overflowX: 'hidden',
      width: '100%',
    },
    '.autocompleteInput__Selected': {
      background: 'palette.primary.main',
      color: 'palette.primary.contrastText',
    },
    '.autocompleteInput__NotSelected': {
      background: 'palette.background.paper',
      color: 'palette.common.black',
    },
  },
};

export default autocompleteInput;
